module.exports = __webpack_public_path__ + "img/start_finished.5a26f41a.svg";